// StepIndicator.tsx
import { m } from "framer-motion";
import { useCommissionStore } from "../stores/commissionStore";
import { STEP_IDS, type StepId } from "../types";
import { useIntakeCopy } from "../i18n/useIntakeCopy";
import { SPRING_TOUCH } from "../motion/tokens";
import { cn } from "@/lib/utils";

export function StepIndicator({ reachable }: { reachable: (s: StepId) => boolean }) {
  const { c } = useIntakeCopy();
  const step = useCommissionStore((s) => s.step);
  const goTo = useCommissionStore((s) => s.goTo);
  const current = STEP_IDS.indexOf(step);
  return (
    <nav aria-label="Progress" className="flex justify-center">
      <ol className="relative flex gap-1 rounded-full border border-[var(--color-border)] bg-[var(--color-bg-card)] p-1">
        {STEP_IDS.map((id, i) => {
          const active = id === step;
          const canGo = i < current || reachable(id);
          return (
            <li key={id}>
              <button type="button" disabled={!canGo || active} onClick={() => goTo(id)}
                aria-current={active ? "step" : undefined}
                className={cn("relative rounded-full px-3 py-1.5 text-xs font-medium sm:px-4 sm:text-sm",
                  active ? "text-[var(--color-bg)]" : i < current ? "text-[var(--color-text)]" : "text-[var(--color-text-muted)]",
                  canGo && !active && "hover:text-[var(--color-primary)]")}>
                {active && <m.span layoutId="step-pill" transition={SPRING_TOUCH} className="absolute inset-0 rounded-full bg-[var(--color-primary)]" />}
                <span className="relative">{c.steps[id]}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
